module.exports = __webpack_public_path__ + "static/media/Portrait-10066_xmas.2fe24f5e.jpg";